module.exports = __webpack_public_path__ + "static/img/Han100K.17d554bd.png";